import { PATH } from '@/shared/constants';

export const FOOTER_WISHKET_INFO_LINKS = [
  {
    name: '요즘IT 소개',
    link: PATH.YOZM_INTRODUCE,
  },
  {
    name: '작가 지원',
    link: PATH.YOZM_AUTHOR_APPLY,
  },
];

export const FOOTER_USAGE_LINKS = [
  {
    name: '콘텐츠 제안하기',
    link: PATH.YOZM_CONTENTS_PROPOSAL,
  },
  {
    name: '광고 상품 보기',
    link: PATH.YOZM_ADVERTISEMENT,
  },
];

export const FOOTER_OTHER_SERVICE_LINKS = [
  {
    name: '요즘IT 슬랙봇',
    link: PATH.SLACKBOT,
    isNewWindow: false,
  },
  {
    name: '크롬 확장 프로그램',
    link: PATH.CHROME_EXTENSION_INSTALL,
    isNewWindow: true,
  },
];

export const EXTERNAL_LINKS = {
  // terms
  TERMS_PRIVACY: 'https://auth.wishket.com/terms/privacy',
  TERMS_SERVICE: 'https://auth.wishket.com/terms/service',
  TERMS_YOUTH_PROTECTION: 'https://auth.wishket.com/terms/youth-protection',
  // other
  YOZMIT: 'https://yozm.wishket.com',
  JOBS: 'https://jobs.wishket.com',
  WISHKET: 'https://www.wishket.com',
};
